import { useNavigate } from "react-router-dom";
import { setLocalStorageItem } from "../../../../hooks/localStorageHooks";
import { IStore } from "../../../../services/api/Store/types";
import { clearFirebaseFolder } from "@/utils/firebase/functions";
import storeApi from "@/services/api/Store";

export const handleDeleteStore = async (store: IStore) => {
  if (window.confirm(`Tem certeza que deseja excluir ${store.name}?`)) {
    try {
      const storeDeletionPromises = [];

      storeDeletionPromises.push(
        clearFirebaseFolder(`peregrin/stores/${store.name}_${store.id}`)
      );
      storeDeletionPromises.push(storeApi.deleteStore(store.id));

      await Promise.all(storeDeletionPromises);
    } catch (error) {
      console.error("Error deleting the store: ", error);
    }
  }
};

const functions = () => {
  const navigate = useNavigate();

  const handleSelectStore = (store: IStore) =>
    setLocalStorageItem("selectedStore", store);

  const handleSeeStoreDetailsClick = (store: IStore) => {
    handleSelectStore(store);
    navigate(`/agencies/details?id=${store.id}`);
  };

  const handleEditStoreClick = (store: IStore) => {
    handleSelectStore(store);
    navigate(`/agencies/edit?id=${store.id}`);
  };

  const handleDeleteManagerStore = (store: IStore) => handleDeleteStore(store);

  return {
    handleSeeStoreDetailsClick,
    handleEditStoreClick,
    handleDeleteManagerStore,
  };
};

export default functions;
